import Domains from '../global/constants/domain';

export const loadDomainSpecificCSS = () => {
    const domain = window.location.hostname;
    if (domain.includes(Domains.ALDI)) {
      document.body.classList.add('aldi-theme');
      // import('../assets/aldi/css/style.css').catch((err) => {
      //   console.error("Error loading CSS for ALDI", err);
      // });
    } else if (domain.includes(Domains.BLOOMS)) {
      // import('../assets/blooms/css/style.css').catch((err) => {
      //   console.error("Error loading CSS for BLOOMS", err);
      // });
      document.body.classList.add('blooms-theme');
    } else if (domain.includes(Domains.MM)) {
      document.body.classList.add('mm-theme');
    
    } else {
      // import('../assets/common/css/style.css').catch((err) => {
        //   console.error("Error loading default CSS", err);
        // });
        document.body.classList.add('mm-theme');
      
    }
   
  };
  